import fuelSurchargesAllComponent from './fuel_surcharges.all.component';

let fuelSurchargesAllModule = angular.module('fuelsurchargesall', [
])

  .component('fuelsurchargesall', fuelSurchargesAllComponent)

  .name;

export default fuelSurchargesAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/all/index.js